<template>
  <div>
    <div class="mb-4">
      <send-attendance-survey survey-type="pruritus" :disabled="disabled"></send-attendance-survey>
    </div>
    <v-row no-gutters>
      <v-col cols="10"><span>Total de dias respondidos</span></v-col>
      <v-col cols="2">
        <v-text-field :disabled="disabled" dense outlined label="Dias" v-model="form.days"></v-text-field>
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col cols="10"><span>Numa escala de 0 a 10, como foi sua coceira nos últimos 30? <br/> Coceira no dia</span></v-col>
      <v-col cols="2">
        <v-text-field :disabled="disabled" dense outlined label="Valor médio" v-model="form.itch"></v-text-field>
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col cols="10"><span>Numa escala de 0 a 10, como foi sua coceira nos últimos 30? <br/> Impacto no sono</span></v-col>
      <v-col cols="2">
        <v-text-field :disabled="disabled" dense outlined label="Valor médio" v-model="form.sleep"></v-text-field>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import { createNamespacedHelpers } from 'vuex'
import SendAttendanceSurvey from '@/components/SendAttendanceSurvey.vue'

const {
  mapMutations: newAttendanceFormMutations,
  mapActions: newAttendanceFormActions,
  mapGetters: newAttendanceFormGetters,
} = createNamespacedHelpers('newAttendanceForm')

export default {
  name: 'PruritusSleepFormNode',
  components: { SendAttendanceSurvey },
  async created() {
    const answer = this.extraAnswers['pruritus-sleep']
    if (answer) {
      this.form = answer
      return
    }

    const surveyId = this.extraAnswers['survey']?.pruritus?.uuid
    if (surveyId) {
      const survey = await this.$api.getSurveyByUuid(surveyId)
      this.form = {
        days: survey.data['days'],
        itch: survey.data['itch'],
        sleep: survey.data['sleep'],
      }
    }
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...newAttendanceFormGetters(['parameters', 'extraAnswers']),
  },
  methods: {
    ...newAttendanceFormMutations(['updateExtraAnswer']),
    ...newAttendanceFormActions(['getParameter', 'getExtraAnswer']),
  },
  data() {
    return {
      form: {
        days: null,
        itch: null,
        sleep: null,
      },
    }
  },
  watch: {
    form: {
      handler(value) {
        this.updateExtraAnswer({ name: 'pruritus-sleep', value })
      },
      deep: true,
    },
  },
}
</script>
<style scoped>
.table div {
  align-items: center;
}

.table div:nth-child(1n + 2) {
  border: solid 1px rgba(0, 0, 0, 0.7);
  margin-right: -1px;
  margin-bottom: -1px;
}

.table div:first-child {
  justify-content: flex-end;
}

.table div div {
  height: 100px;
}

.rate-ten > div {
  align-self: center;
  width: fit-content;
  border: 1px solid black;
  padding: 12px 24px;
}

@media (max-width: 425px) {
}
</style>
